var exports = {
  "k": "xb99ab02a--a1a312--container",
};

module.exports = exports;
